export const LEARN_DASHBOARD_PAGE_NAME = 'Learn Dashboard';
export const LEARN_DASHBOARD_PAGE_KEY = 'homepage';

export const APP_ID = 'mevliu65';
export const APP_ID_QA = 'if08s3kq';

export enum LEARN_DASHBOARD_FEATURE_FLAGS {
  LEARNING_FOUNDATION_LIDER = 'LEARNING_FOUNDATION_LIDER',
  NEW_SIDEBAR_LAYOUT = 'NEW_SIDEBAR_LAYOUT',
  USER_NOTIFICATION_WEB = 'user_notification_web',
}
